/* tslint:disable */
/* eslint-disable */
export enum ContactTypeEnum {
  Primary = 'Primary',
  Secondary = 'Secondary',
  Guarantor = 'Guarantor'
}
